import { render, staticRenderFns } from "./RiskAssessmentAlways.vue?vue&type=template&id=5bc4ec56&scoped=true&"
import script from "./RiskAssessmentAlways.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentAlways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc4ec56",
  null
  
)

export default component.exports